import React, { useEffect, useState } from "react";
import api from '../../services/api';
import Modal from 'react-modal';
import Flex from '@react-css/flex';
import Swal from "sweetalert2";
import { StyledForm } from "../../styled-components/StyledForm.style";

export const ModalCalendarioFeriadosEventosAdicionarAno = ({ isOpen, setIsOpen, onRequestClose }) => {
    const [isLoading, setisLoading] = useState(false);
    const [anosCadastrados, setAnosCadastrados] = useState([]);

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '40%',
            overflowY: 'auto',
            minHeight: '30%',
            maxHeight: '90%',
            padding: '20px'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const gerarListaAnos = () => {
        const anoAtual = new Date().getFullYear();
        const lista = [];
        for (let i = -2; i <= 2; i++) {
            lista.push(anoAtual + i);
        }
        return lista;
    };

    const anosParaExibir = gerarListaAnos();

    const closeModal = () => {
        setisLoading(false);
        setIsOpen(false);
        if (onRequestClose) onRequestClose();
    }

    const handleSelecionarAno = async (ano) => {
        setisLoading(true);

        try {
            await api.post(`WipRecesso/${ano}`);
            
            Swal.fire({
                title: 'Sucesso!',
                text: `O calendário para o ano ${ano} foi inicializado.`,
                icon: 'success',
                //confirmButtonColor: '#EE4B21'
                timer: 2000,
                timerProgressBar: true,
                showConfirmButton: false
            }).then(() => {
                setAnosCadastrados([...anosCadastrados, ano]);
                closeModal();
            });
        } catch (error) {
            console.error(`Erro ao tentar adicionar o ano ${ano}:`, error);
            Swal.fire({
                title: 'Erro',
                text: 'Não foi possível inicializar o calendário para este ano. Tente novamente mais tarde.',
                icon: 'error',
                confirmButtonColor: '#EE4B21'
            });
        } finally {
            setisLoading(false);
        }
    };

    // Busca os anos cadastrados ao abrir o modal
    useEffect(() => {
        const buscarAnosNoBanco = async () => {
            if (!isOpen) return;

            setisLoading(true);
            try {
                const response = await api.get('WipRecesso/list');
                const listaAnos = response.data.data ? response.data.data.map(item => item.anoCompetencia) : [];
                
                setAnosCadastrados(listaAnos);
            } catch (error) {
                console.error("Erro ao buscar a lista de anos cadastrados:", error);
                Swal.fire('Erro', 'Falha ao carregar os anos já configurados.', 'error');
            } finally {
                setisLoading(false);
            }
        };

        buscarAnosNoBanco();
    }, [isOpen]);

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            contentLabel="Modal Adicionar Ano"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div className="pull-left">
                                <p className="modal-title">
                                    <i className="fa fa-calendar-plus-o pe-2" style={{ fontSize: '24px', color: '#EE4B21' }}></i>
                                    Selecionar Ano para Configuração
                                </p>
                            </div>
                            <div className="pull-right">
                                <p className="modal-close" onClick={closeModal}>
                                    <button type="button" className="default-button-red-small px-2">X</button>
                                </p>
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>

                { isLoading ? 
                (
                    <div className="text-center py-4">
                        <div className="spinner-border" style={{ color: "#EE4B21" }} role="status"></div>
                        <div className="mt-2">
                            <strong style={{ color: "#EE4B21" }}>Processando abertura do calendário...</strong>
                        </div>
                    </div>
                ) : (
                    <div style={{ padding: '10px' }}>
                        <p className="mb-4 text-secondary">
                            Selecione um ano abaixo para criar o calendário de feriados e eventos. 
                            Anos marcados em cinza já possuem configurações ativas.
                        </p>
                        
                        <div style={{ 
                            display: 'grid', 
                            gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', 
                            gap: '15px',
                            justifyContent: 'center' 
                        }}>
                            {anosParaExibir.map(ano => {
                                const jaExiste = anosCadastrados.includes(ano);
                                
                                return (
                                    <button
                                        key={ano}
                                        type="button"
                                        disabled={jaExiste}
                                        onClick={() => handleSelecionarAno(ano)}
                                        style={{
                                            padding: '20px',
                                            fontSize: '18px',
                                            fontWeight: 'bold',
                                            borderRadius: '8px',
                                            border: 'none',
                                            cursor: jaExiste ? 'not-allowed' : 'pointer',
                                            backgroundColor: jaExiste ? '#ccc' : '#EE4B21',
                                            color: '#fff',
                                            transition: 'transform 0.2s, opacity 0.2s',
                                            boxShadow: jaExiste ? 'none' : '0 4px 6px rgba(0,0,0,0.1)'
                                        }}
                                        onMouseOver={(e) => !jaExiste && (e.currentTarget.style.transform = 'scale(1.05)')}
                                        onMouseOut={(e) => !jaExiste && (e.currentTarget.style.transform = 'scale(1)')}
                                    >
                                        {ano}
                                        {jaExiste && <div style={{ fontSize: '10px', marginTop: '5px' }}>JÁ CADASTRADO</div>}
                                    </button>
                                );
                            })}
                        </div>

                        <div className="mt-5 text-end">
                            <button 
                                type="button" 
                                onClick={closeModal}
                                className="btn btn-light"
                                style={{ border: '1px solid #ccc' }}
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                )}
            </StyledForm>
        </Modal>
    );
}